import { render } from "./VehicleImage.vue?vue&type=template&id=5a9c15de&scoped=true"
import script from "./VehicleImage.vue?vue&type=script&lang=js"
export * from "./VehicleImage.vue?vue&type=script&lang=js"

import "./VehicleImage.vue?vue&type=style&index=0&id=5a9c15de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9c15de"]])

export default __exports__